import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Newsletter from "../Widget/Newsletter";
import IconBoxStyle11 from "../IconBox/IconBoxStyle11";
import Spacing from "../Spacing";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";

export default function Header({ logoSrc, variant }) {
  const { t } = useTranslation();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header ${
          mobileToggle ? "cs_mobile_toggle_active" : ""
        } ${isSticky ? "cs_active_sticky cs_heading_color" : (isHomePage ? variant : "cs_heading_color")}`}
      >
        <div className="cs_main_header">
          <div className="container">
            <div className="cs_main_header_in">
              {/* LEFT SIDE */}
              <div className="cs_main_header_left">
                <Link className="cs_site_branding" to="/">
                   <img src={logoSrc} alt="Logo" />
                </Link>

                <nav className="cs_nav">
                  <ul
                    className={`${
                      mobileToggle ? "cs_nav_list cs_active" : "cs_nav_list"
                    }`}
                  >
                    <li>
                      <Link to="/" onClick={() => setMobileToggle(false)}>{t("nav.nav_home")}</Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={() => setMobileToggle(false)}>{t("nav.nav_about")}</Link>
                    </li>
                    <li>
                      <Link to="/services" onClick={() => setMobileToggle(false)}>{t("nav.nav_services")}</Link>
                    </li>
                    <li>
                      <Link to="/blog" onClick={() => setMobileToggle(false)}>{t("nav.nav_blog")}</Link>
                    </li>
                    <li>
                      <Link to="/pharmacovigilance" onClick={() => setMobileToggle(false)}>
                        {t("nav.nav_pharmacovigilance")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" onClick={() => setMobileToggle(false)}>{t("nav.nav_contact")}</Link>
                    </li>
                  </ul>

                  <span
                    className={
                      mobileToggle
                        ? "cs_menu_toggle cs_teggle_active"
                        : "cs_menu_toggle"
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </nav>
              </div>

              {/* RIGHT SIDE */}
              <div className="cs_main_header_right">
                <div className="cs_toolbox">
                  <LanguageSwitcher />

                  <button
                    className="cs_toolbox_btn cs_sidebar_toggle_btn"
                    type="button"
                    onClick={() => setSideNav(!sideNav)}
                  >
                    <svg
                      width={35}
                      height={30}
                      viewBox="0 0 35 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.483887 2.46544C0.483887 1.10383 1.14618 0 1.96315 0H33.5208C34.3377 0 35 1.10383 35 2.46544C35 3.82708 34.3377 4.93088 33.5208 4.93088H1.96315C1.14618 4.93088 0.483887 3.82708 0.483887 2.46544Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0.483887 14.6694C0.483887 13.3074 1.14618 12.2039 1.96315 12.2039H33.5208C34.3377 12.2039 35 13.3074 35 14.6694C35 16.0309 34.3377 17.1348 33.5208 17.1348H1.96315C1.14618 17.1348 0.483887 16.0309 0.483887 14.6694Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0.483887 26.6267C0.483887 25.2648 1.14618 24.1613 1.96315 24.1613H33.5208C34.3377 24.1613 35 25.2648 35 26.6267C35 27.9883 34.3377 29.0922 33.5208 29.0922H1.96315C1.14618 29.0922 0.483887 27.9883 0.483887 26.6267Z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* SIDE NAV */}
      <div className={`cs_sidenav ${sideNav ? "active" : ""}`}>
        <div
          className="cs_sidenav_overlay"
          onClick={() => setSideNav(!sideNav)}
        />
        <div className="cs_sidenav_in">
          <button
            className="cs_close"
            type="button"
            onClick={() => setSideNav(!sideNav)}
          >
            <img src="/images/icons/close.svg" alt="Close" />
          </button>

          <div className="cs_logo_box">
            <img src="/images/logo.svg" alt="Logo" />
            <div className="cs_height_15" />
            <h3 className="cs_fs_24 cs_semibold mb-0">{t("nav.side_title")}</h3>
          </div>

          <Spacing md="35" lg="35" xl="35" />
          <hr />
          <Spacing md="35" lg="50" xl="35" />

          <div className="d-flex justify-content-center">
            <LanguageSwitcher />
          </div>

          <Spacing md="35" lg="35" xl="35" />

          <IconBoxStyle11
            title={t("nav.side_phone")}
            subTitle="04 243 4233"
            iconSrc="/images/contact/icon_1.svg"
          />

          <Spacing md="30" lg="30" xl="30" />

          <IconBoxStyle11
            title={t("nav.side_email")}
            subTitle="info@incomed.al"
            iconSrc="/images/contact/icon_2.svg"
          />

          <Spacing md="30" lg="30" xl="30" />

          <IconBoxStyle11
            title={t("nav.side_location")}
            subTitle="8P2V + Q3Q, SH56, Vaqarr"
            iconSrc="/images/contact/icon_3.svg"
          />

          <Spacing md="60" lg="60" xl="60" />
          <Newsletter />

        </div>
      </div>
    </>
  );
}
